import { Component, DestroyRef, inject, Input } from '@angular/core';
import { serverurl } from '../../../../environments/environment';
import { UserdataService } from '../../../service/userdata.service';
import { AuthandregistryService } from '../../../service/authandregistry.service';
import { MatDialog } from '@angular/material/dialog';
import { UseraccountComponent } from '../../user/useraccount/useraccount.component';
import packageJson from '../../../../../package.json';
import { HealthService } from '../../../service/health.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'rr-usermenue',
    standalone: false,
    templateUrl: './usermenue.component.html',
    styleUrl: './usermenue.component.scss'
})
export class UsermenueComponent {
    user: any;
    userAccountMenueIsOpen: boolean = false;
    serverurl = serverurl;
    @Input() showName: boolean = true;
    dialog = inject(MatDialog);

    protected healthService = inject(HealthService);
    private destroyRef = inject(DestroyRef);

    protected appVersion: string = packageJson.version;

    constructor(
        private userdata: UserdataService,
        private auth: AuthandregistryService,
    ) {
        this.userdata.data.subscribe(data => {
            this.user = data;
        });

    }

    toggleUserMenue() {
        this.userAccountMenueIsOpen = !this.userAccountMenueIsOpen;

        if (this.userAccountMenueIsOpen) {
            this.healthService.getServerVersion$()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe();
        }
    }

    logout() {
        this.toggleUserMenue();
        this.auth.doLogOut();
    }
    switchLanguage() {
        this.toggleUserMenue();
    }
    openSettings() {
        this.toggleUserMenue();
        this.dialog.open(UseraccountComponent, {
            panelClass: "full-screen",
            autoFocus: false,
            data: {
                activeStep: 1
            }
        });
    }
}

